<template>
  <div v-if="isLoading || isUserSending"><sync-loader class="text-center" color="white"></sync-loader></div>
</template>

<script>
  import swal from 'sweetalert2'
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'
  import { mapActions, mapGetters } from 'vuex'
  import { USER_SEND_PATCH } from "../store/actions/userConst";
 
  export default {
    name: "Confirm",
    computed: {
      ...mapGetters(['isLoading', 'isUserSending', 'isLogin', 'RxIsLoadProfile'])
    },
    methods: {
      ...mapActions([USER_SEND_PATCH])
    },
    data() {
      return {
        RxIsLoadProfilePointer: null,
      }
    },
    components: {syncLoader},
    props: {
      uid: {type: String, default: null}
    },
     beforeDestroy() {
       if(this.RxIsLoadProfilePointer) this.RxIsLoadProfilePointer.unsubscribe()
    },
   created() {
     if (this.isLogin) {
      if (this.uid) {
        this.RxIsLoadProfilePointer = this.RxIsLoadProfile.subscribe(usr=>{
          if(usr) {
            if(usr.id != this.uid) {
              swal({
                type: 'error',
                text: this.$t('u_wrong_link'),
                keydownListenerCapture: true,
                allowOutsideClick: false
              })
              this.$router.push({name: 'home'})
            } else {
              this.USER_SEND_PATCH({id: this.uid, data_change: {isNewsLettersAllowed: false}})
                .then(()=>{
                  swal({
                    type: 'success',
                    text: this.$t('u_successful_confirmation'),
                    keydownListenerCapture: true,
                    allowOutsideClick: false
                  })
                  this.$router.push({name: 'profile', params: {id: this.uid}})
                })
                .catch((err)=>{
                  swal({
                    type: 'error',
                    text: this.$t('text16'),
                    keydownListenerCapture: true,
                    allowOutsideClick: false
                  })
                  console.log(err);
                })
            }
          };
        });
      } else {
        swal({
          type: 'error',
          text: this.$t('u_wrong_link'),
          keydownListenerCapture: true,
          allowOutsideClick: false
        })
        this.$router.push({name: 'home'})
      }
     } else {
        swal({
          type: 'error',
          text: this.$t('u_must_login'),
          keydownListenerCapture: true,
          allowOutsideClick: false
        })
        this.$router.push({name: 'login'})
     }
    }
  }
</script>

<style lang="scss" scoped>
  div {
    width: 100%;
    text-align: center;
  }
</style>